module.exports = __webpack_public_path__ + "static/img/houdini.bb77cad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/software/houdini.jpg
// module id = 607
// module chunks = 2